import React, { useRef, useCallback, useEffect } from 'react';
import OptionList from './../../OptionList/OptionList';
import { OptionListProps } from '../../OptionList/OptionList';
import style from '../Breadcrumb.module.scss';

type BreadcrumbTruncatedItemsProps = OptionListProps & {
  onClose: () => void;
};
export const BreadcrumbTruncatedItems: React.FunctionComponent<BreadcrumbTruncatedItemsProps> = ({
  onClose,
  optionOnClick,
  options,
  className,
}) => {
  const ref = useRef(null);
  const escapeListener = useCallback(
    /* istanbul ignore next  */
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose && onClose();
      }
    },
    []
  );

  const clickListener = useCallback(
    /* istanbul ignore next  */
    (e: MouseEvent) => {
      if (ref.current) {
        if (!(ref.current as any).contains(e.target)) {
          onClose && onClose();
        }
      }
    },
    [ref.current]
  );

  useEffect(() => {
    document.addEventListener('click', clickListener);
    document.addEventListener('keyup', escapeListener);
    return () => {
      document.removeEventListener('click', clickListener);
      document.removeEventListener('keyup', escapeListener);
    };
  }, []);

  return (
    <div ref={ref} className={style.breadcrumb_truncated_wrapper}>
      <OptionList
        noBorderBottom
        className={className}
        optionOnClick={optionOnClick}
        options={options}
      ></OptionList>
    </div>
  );
};

export default BreadcrumbTruncatedItems;
